import axios from 'axios'
import { BASEURL } from '../datatypes/deployment';

export function requestSubscribedBiasUsers(uid: number,
                                           symbol?: String,
                                           traderType?: String) {

    const requestParameters = {
        "uid": uid,
        "symbol": symbol,
        "trader_type": traderType
    };

    const baseURL = BASEURL + "/biassubscription/subscribedbias";
    return axios.post(baseURL, requestParameters).then((response) => {
        const data = response.data;
        if (response.status === 200) {
            // console.log("requestSubscribedBiasUsers() -> data : ",data)
            return {
                data: data
            }
        }
    }).catch((error) => {
        return {
            data: {error: error}
        }
    })
}

export function requestMaxSubscriptions(level: number) {

    const requestParameters = {
        "user_level": level
    };

    const baseURL = BASEURL + "/biassubscription/sub_count";
    return axios.post(baseURL, requestParameters).then((response) => {
        const data = response.data;
        if (response.status === 200) {
            return {
                data: data
            }
        }
    }).catch((error) => {
        return {
            data: {error: error}
        }
    })
}

// export function updateSubscribedBiasUsersDB(uid: number,
//     symbol: String,
//     traderType: String,
//     discordUsername: String,
//     biasList: number[]) {

//     const parameters = {
//         "uid": uid,
//         "symbol": symbol,
//         "trader_type": traderType,
//         "discord_name": discordUsername,
//         "bias_list": biasList
//     };

//     const baseURL = "https://mcm-api-dev-v2.askslim.org/biassubscription/updatesubscribedbias";
//     return axios.post(baseURL, parameters).then((response) => {
//         const data = response.data;
//         if (response.status === 200) {
//             return {
//                 data: data
//             }
//         }
//     }).catch((error) => {
//         return {
//             data: {error: error}
//         }
//     })
// }

export function updateSubscribedBiasUsersDB(uid: number,
    symbol: String,
    traderType: String,
    discordUsername: String,
    biasList: number[]) {

    const parameters = {
        "uid": uid,
        "symbol": symbol,
        "trader_type": traderType,
        "discord_name": discordUsername,
        "bias_list": biasList   
    };

    const baseURL = BASEURL + "/biassubscription/updatesubscribedbias";
    
    return axios.post(baseURL, parameters).then((response) => {
        const data = response.data;
        if (response.status === 200) {
            return {
                data: data
            }
        }
    }).catch((error) => {
        return {
            data: {error: error}
        }
    })
}

export function deleteSubscribedBiasUsers(uid: number) {
    const parameters = {
        "uid": uid,
    }

    const baseURL = BASEURL + "/biassubscription/deleteallsubs"; 
    return axios.post(baseURL, parameters).then((response) => {
        const data = response.data;
        if (response.status === 200) {
            return {
                data: data
            }
        }
    }).catch((error) => {
        return {
            data: {error: error}
        }
    })
}